import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  AiOutlineCheckCircle,
  AiOutlineInfoCircle,
  AiOutlineWarning,
  AiOutlineCloseCircle,
} from 'react-icons/ai';

function AlertMessage({ message, type = 'info', onClose, duration = 3000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const typeStyles = {
    success: 'bg-green-600 text-white',
    error: 'bg-red-600 text-white',
    warning: 'bg-yellow-500 text-black',
    info: 'bg-blue-600 text-white',
  };

  const icons = {
    success: <AiOutlineCheckCircle className="w-6 h-6 mr-3" />,
    error: <AiOutlineCloseCircle className="w-6 h-6 mr-3" />,
    warning: <AiOutlineWarning className="w-6 h-6 mr-3" />,
    info: <AiOutlineInfoCircle className="w-6 h-6 mr-3" />,
  };

  return (
    <div
      className={`fixed top-5 right-5 z-50 flex items-center p-4 rounded-lg shadow-md transition-transform transform ${typeStyles[type]}`}
    >
      {icons[type]}
      <span className="flex-1 text-base font-medium">{message}</span>
      <button onClick={onClose} className="ml-4 text-white hover:text-gray-300">
        <AiOutlineCloseCircle className="w-5 h-5" />
      </button>
    </div>
  );
}
AlertMessage.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default AlertMessage;
